import React, { Component } from "react";
//import echarts from "echarts";
import * as echarts from 'echarts';
import download from "./downloadCSV.jpg";

//import "echarts/lib/chart/line";
//import "echarts/lib/component/toolbox";
//import "echarts/lib/component/tooltip";
//import "echarts/lib/component/title";
//////import saveAs from "file-saver"; // Import saveAs from file-saver library

//import "echarts/lib/component/dataZoom";

import close from "../../minimise_button.png";
import moment from "moment";
import { toolbox as features } from 'echarts/lib/langEN'


class CChart extends Component {
  componentDidMount() {
    this.renderChart();
  }

  componentDidUpdate() {
    this.renderChart();
  }





  exportToCSV = () => {
    const { seriesData, title } = this.props;
  
    // Convert data to CSV format
    let csvContent = `${this.props.xAxisTitle},${this.props.yAxisTitle.split(" ")[0]}  at (${this.props.long.toFixed(3)} & ${this.props.lat.toFixed(3)})\n`;
   

    const timestampSelected = this.props.selected.split("-")[2]
    seriesData.forEach(([timestamp, value]) => {
      let prefix;
      if ( timestampSelected === 'Monthly750' ) {
        const date = moment(timestamp);
        prefix = date.format("MMM YYYY");
      } 
      
      if (timestampSelected === 'Fortnightly750' ){
        prefix=timestamp

      } 
      
      else {
        prefix = moment(timestamp).format("DD MMM YYYY");
      }
      const formattedValue = value !== null ? value : 'Cloud';
      csvContent += `${prefix},${formattedValue}\n`;
    });
  
    // Create a Blob containing the CSV data
    const csvBlob = new Blob([csvContent], { type: "text/csv;charset=utf-8" });
  
    // Create a link element and trigger a download
    const a = document.createElement('a');
    a.href = URL.createObjectURL(csvBlob);
    a.download = `${this.props.yAxisTitle.split(" ")[0] +"_"+this.props.long.toFixed(3)+"_"+this.props.lat.toFixed(3) }.csv`;
    a.click();
  };
  
  renderChart() {
    const { seriesData, name, yAxisTitle, toggleVisibleGraphPanel,title,selected } = this.props;

    const chart = echarts.init(document.getElementById("chart-container"));

    

    const option = {
      color: ["#3398DB"],
      title: {
        top: '5%',
        left: 'center',
        text: title
      },

     
      // brush: {
      //  toolbox: ['rect', 'polygon', 'lineX', 'lineY','keep','clear'],
      //  xAxisIndex: 0
      // },
      
      toolbox: {
        show: true,
       
       
        feature: {
         
          dataZoom: {
           
            yAxisIndex: 'none',
            title: {
              zoom: 'Zoom In',
              back: 'Zoom Out',
            },
          
          },
          // brush: {
          //   type: ['rect', 'polygon', 'lineX', 'lineY','keep','clear'],
          //   title: {
          //     rect: 'Select Rectangular Area',
          //     polygon: 'Select Polygon Area',
          //     lineX: 'Select Horizontal Line',
          //     lineY: 'Select Vertical Line',
          //     keep: 'Keep Original',
          //    clear: 'Clear Selection',
             
          //   },
          
    
          //},
          magicType: {
            type: ["bar","line"],

            title: {
              line: 'Line Chart',
              bar: 'Bar Chart',
              //stack: 'Stacked Chart',
             // keep: 'Keep Original',
              //clear: 'Clear All',
            },
          },
            //dataView: { title: 'View Points', lang:['Evapotranspiration Data','close','Refresh'],show: true,readOnly: false ,download:true},
            dataView: { 
              download:true,
              show: true, 
              title: 'View Data Points',
              readOnly: false, // Whether the data view is read-only or editable
              lang:[`${this.props.title}`,'close','Refresh'], // Custom language for the data view button
              textareaBorderColor: '#fff', // Border color of the textarea in the data view panel
              onclick: function(){
                // Custom action when the data view button is clicked
                // This function can be used to trigger a modal or any other action you want
              },
             
              optionToContent: () => {
                const { seriesData, title } = this.props;
                let timestampSelected = this.props.selected.split("-")[2]
                console.log("timeselected is", timestampSelected);
                let table = '<table style="width:100%;text-align:center"><tbody>';
                // Add table headers
                table += `<tr><td>`+this.props.xAxisTitle+`</td><td>` + this.props.yAxisTitle.split(" ")[0] +" at "+this.props.long.toFixed(3)+", "+this.props.lat.toFixed(3)+" (lon,lat) " + '</td></tr>';
                // Add table rows
                seriesData.forEach(([timestamp, value]) => {
                  let prefix;
                  if (timestampSelected === 'Monthly750' ) {
                    console.log("elseee if",timestampSelected)

                    const date = moment(timestamp);
                    prefix =  date.format("MMM YYYY");

                    
                  } if (timestampSelected==='Fortnightly750'){
                   prefix=timestamp


                  }
                  
                  
                  else {
                    console.log("elseeeeeeee",timestampSelected)
                    prefix = moment(timestamp).format("DDMMMYYYY").toUpperCase(); // Format timestamp to "ddMMMYYYY"
                  }
                  const formattedValue = value !== null ? value : 'Cloud'; // Use value directly
                  table += '<tr><td>' + prefix + '</td><td>' + formattedValue + '</td></tr>';
                });
                table += '</tbody></table>';
                return table;
              }
              
              
  
            },
            restore: {title: 'Restore', show: true},

          saveAsImage: {
            show: true,
            title: "Save As Image",
          },
          myExportCSV: {  // Custom CSV button
            show: true,
            title: "Export to CSV",
            icon: `image://${download}`,  // You can replace this with the path to your custom icon
            onclick: this.exportToCSV,
          },
          myClose: {
            show: true,
            title: "Minimize",
            icon: `image://${close}`,
            onclick: toggleVisibleGraphPanel,
          },
        //  mySaveAsCSV: { // Custom CSV button
          //  show: true,
          //  title: "Save As CSV",
           // onclick: () => this.saveAsCSV(seriesData),
         // },
        },
      },

  
      // legend: {
      //   bottom: '-3%',
      //   left: 'center',
      // },
      xAxis: {
        type: this.props.selected.split("-")[2] === "Fortnightly750" ? "category" : "time",

        data: this.props.selected.split("-")[2] === "Fortnightly750"?
        seriesData.map(entry => entry[0]) : 
        (this.props.selected.split("-")[2] === "Monthly750" ? 
        seriesData.map(entry => moment(entry[0]).format("MMM YYYY")) :
        seriesData.map(entry => moment(entry[0]).format("DD MMM YYYY"))),

       // data:seriesData.map(timestamp => moment(timestamp).format("DD MMM YYYY")),
        //seriesData.map(timestamp =>timestamp[0]) ,

        name:this.props.xAxisTitle,
        nameTextStyle: {
          //align: "center",
          fontWeight: "bold", // Set to "bold" to make the name bold

          lineHeight: 50
        },
       
        axisLabel: {
          //interval: 2, 
         // rotate: 45,// 
          formatter: (value, index) => {
            let prefix;
            let label = value;

            let timestampSelected = this.props.selected.split("-")[2];
            if (timestampSelected === 'Monthly750' ) {
              return prefix = moment(value).format("MMM YYYY");
              //prefix = date;
            } 
            if(timestampSelected ===  'Fortnightly750'){
          //   if(timestampSelected ===  'Fortnightly'){
            return  label // No need for formatting since the labels are already in the desired format
            }
            
            
            else {
             return  prefix = moment(value).format("DD MMM YYYY");
            }
            //return prefix;
          },
         
        },
      
        label: {
          show: true,
          position: 'top', // or 'insideTop', 'insideBottom', etc.
        },
        splitLine: {
          show: false  // Remove x-axis split lines (vertical grid lines)
        },
        boundaryGap: false,

      },
      
      yAxis: {
        type: "value",
        nameLocation: "middle",

        name: yAxisTitle,
        
        nameTextStyle: {
          align: "center",
          verticalAlign: "bottom",
          fontWeight: "bold", // Set to "bold" to make the name bold

          lineHeight: 50
        },
        splitLine: {
          show: false  // Remove x-axis split lines (vertical grid lines)
        },
        min:this.props.yAxisTitle=="ESI"? -3 : undefined,
        max:this.props.yAxisTitle=="ESI"? 3 : undefined,


      },
      // tooltip: {
      //   trigger: "axis",
      //   axisPointer: {
      //     animation: false,
      //   },
      //   formatter: (params) => {
      //     let date;
      //     const timestampSelected = this.props.selected.split("-")[2];

      //     if (timestampSelected === 'Fortnightly750' || timestampSelected === 'Monthly750' ) {
      //       const timestamp = params[0].value[0];
      //       const momentDate = moment(timestamp);
      //       date =  momentDate.format("MMM YYYY");



      //     } else {
      //       date = moment(params[0].value[0]).format("DD MMM YYYY");
      //     }
      //     const value = params[0].value[1] === null ? "Cloud" : `${params[0].value[1]}`;
      //     return `${date}: ${value}`;
      //   },
      // },

      tooltip: {
        trigger: "axis",
        axisPointer: {
          animation: false,
        },
        formatter: (params) => {
          let date;
          const timestampSelected = this.props.selected.split("-")[2];

        
      
          if (timestampSelected === 'Fortnightly750' ) {
            date = params[0].value[0];
          } else if (timestampSelected === 'Monthly750' ) {
            date = moment(params[0].value[0]).format("MMM YYYY");
          } else {
            date = moment(params[0].value[0]).format("DD MMM YYYY");
          }
      
          const value = params[0].value[1] === null ? "Cloud" : `${params[0].value[1]}`;
          return `${date}: ${value}`;
        },
      },
      
      
      dataZoom: [
        {
          type: "inside",
          xAxisIndex: 0,
        },
        {
          show: true,
          type: "slider",
          xAxisIndex: 0,
          start: 0,
          end: 100,
        },
      ],
      series: [
        {
          name: name,
         type : "line",
          data: seriesData,
          connectNulls: false,

        },
      ],
    };

    chart.setOption(option);
  }
  //saveAsCSV(seriesData) {
    //const csvContent = "data:text/csv;charset=utf-8," +
     // "Timestamp,Value\n" +
     // seriesData.map(([timestamp, value]) => `${moment(timestamp).format("DD MMM YYYY")},${value}`).join("\n");

    //const csvBlob = new Blob([csvContent], { type: "text/csv;charset=utf-8" });
   // saveAs(csvBlob, "data.csv");
  //}

  render() {


    console.log("selected layerrr" ,this.props.fortnight,this.props.selected.split("-")[2],this.props.title,this.props.selected,this.props.title.split(" ")[2],this.props.seriesData)

    return (
      <div>
        <div id="chart-container" style={{ height: "400px" }} />

    
    </div>
    );
  }
}

export default CChart;
